module.exports = __webpack_public_path__ + "img/bornutti19.30533eff.jpg";